var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-outline-success py-2 px-4",staticStyle:{"border-color":"transparent"},attrs:{"type":"button"},on:{"click":_vm.onExport}},[_c('i',{staticClass:"fas fa-file-download"})])}
var staticRenderFns = []

export { render, staticRenderFns }